(function () {
  const STRAP_PRODUCT_HANDLE = 'gruvtube-strap-bundle';
  const INVALID_CLASS = 'cart__checkout-button--invalid';

  function readCartItems() {
    const rows = document.querySelectorAll('#main-cart-items .cart-item, #CartDrawer-CartItems .cart-item');
    let tubeQty = 0;
    let strapQty = 0;
    rows.forEach((row) => {
      const handle = row.dataset.productHandle;
      const qty = parseInt(row.dataset.quantity, 10) || 0;
      if (handle === STRAP_PRODUCT_HANDLE) {
        strapQty += qty;
      } else if (row.dataset.requiresStrap === 'true') {
        tubeQty += qty;
      }
    });
    return { tubeQty, strapQty };
  }

  function validate() {
    const { tubeQty, strapQty } = readCartItems();
    if (tubeQty > 0 && strapQty < tubeQty) {
      return { valid: false, message: 'Each GruvTube requires a strap. Please select a strap before checking out.' };
    }
    if (strapQty > 0 && tubeQty === 0) {
      return { valid: false, message: 'Straps require a tube. Please add a tube to your cart before checking out.' };
    }
    if (strapQty > tubeQty) {
      return {
        valid: false,
        message: `You have ${strapQty} strap${strapQty === 1 ? '' : 's'} but only ${tubeQty} tube${tubeQty === 1 ? '' : 's'}. Add another tube or remove a strap.`,
      };
    }
    return { valid: true, message: null };
  }

  function applyState(result) {
    const buttonIds = ['checkout', 'CartDrawer-Checkout', 'cart-notification-checkout'];
    buttonIds.forEach((id) => {
      const btn = document.getElementById(id);
      if (!btn) return;
      if (result.valid) {
        btn.classList.remove(INVALID_CLASS);
        if (btn.dataset.validationDisabled === 'true') {
          btn.disabled = false;
          delete btn.dataset.validationDisabled;
        }
      } else {
        btn.classList.add(INVALID_CLASS);
        if (!btn.disabled) {
          btn.disabled = true;
          btn.dataset.validationDisabled = 'true';
        }
      }
    });

    // Shop Pay / PayPal / Apple Pay / Google Pay navigate via their own
    // mechanism (often an iframe), so click interception is unreliable.
    // Instead we hard-disable the buttons when the cart is invalid: display:none
    // with !important priority beats any theme stylesheet rule, and
    // pointer-events + aria-disabled are belt-and-suspenders. This is why the
    // previous `el.hidden` approach failed -- Dawn's CSS set an explicit
    // `display` on the container, overriding the UA `hidden` style.
    const dynamicCheckoutEls = document.querySelectorAll(
      '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button'
    );
    dynamicCheckoutEls.forEach((el) => {
      if (result.valid) {
        el.hidden = false;
        el.style.removeProperty('display');
        el.style.removeProperty('pointer-events');
        el.removeAttribute('aria-disabled');
      } else {
        el.hidden = true;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('aria-disabled', 'true');
      }
    });

    ['cart-errors', 'CartDrawer-CartErrors'].forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      if (result.valid) {
        if (el.dataset.validationOwned === 'true') {
          el.textContent = '';
          delete el.dataset.validationOwned;
        }
      } else {
        el.textContent = result.message;
        el.dataset.validationOwned = 'true';
      }
    });
  }

  let observer = null;
  let runScheduled = false;

  function run() {
    // Disconnect while we mutate the button/error/payment-button ourselves so
    // applyState's own DOM changes don't retrigger the observer (infinite loop).
    if (observer) observer.disconnect();
    applyState(validate());
    attachSubmitListeners();
    if (observer) observeContainers();
  }

  // Coalesce the many re-render notifications (a single cart update can fire
  // several mutations) into one validation pass on the next tick.
  function requestRun() {
    if (runScheduled) return;
    runScheduled = true;
    setTimeout(() => {
      runScheduled = false;
      run();
    }, 0);
  }

  function observeContainers() {
    if (typeof MutationObserver === 'undefined') return;
    if (!observer) {
      observer = new MutationObserver(requestRun);
    }
    // Observe the STABLE wrappers whose descendants get re-rendered. The cart
    // drawer footer + form + checkout button all live inside <cart-drawer>, and
    // that element itself is never replaced -- only its contents are. This
    // catches every re-render path (updateQuantity, onCartUpdate's async fetch,
    // renderContents, and strap-selector's refreshCartDrawer) even when they
    // publish no cartUpdate event.
    [
      document.querySelector('cart-drawer'),
      document.getElementById('main-cart-items'),
      document.getElementById('main-cart-footer'),
      document.getElementById('cart-notification'),
    ].forEach((el) => {
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  function onSubmit(event) {
    const result = validate();
    if (!result.valid) {
      event.preventDefault();
      applyState(result);
    }
  }

  function attachSubmitListeners() {
    ['cart', 'CartDrawer-Form', 'cart-notification-form'].forEach((id) => {
      const form = document.getElementById(id);
      if (form && form.dataset.validationBound !== 'true') {
        form.addEventListener('submit', onSubmit);
        form.dataset.validationBound = 'true';
      }
    });
  }

  function init() {
    observeContainers();
    run();
    // Keep the pubsub subscription as defense-in-depth for updates that don't
    // structurally change the DOM; the observer handles the re-render races.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, requestRun);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
